import api from "@/lib/axios";

export const universityService = {


  fetchUniversities: async () => {
    try {
      const response = await api.get("form/university");
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch universities: " + error.message);
    }
  },
  

};

  

